import React, { useEffect, useRef, useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import { projectData } from '../data/projectData'; // ✅ Ensure this exists
import '../styles/ChatBot.css'; // ✅ Use correct CSS path

const VoltBot = () => {
  const [open, setOpen] = useState(false);
  const [input, setInput] = useState('');
  const [messages, setMessages] = useState([
    {
      from: 'bot',
      text: '⚡ Hello! I’m VoltBot — Arka’s Electrical AI Assistant. Ask me about his skills, projects, or even say “I love you”! ❤️',
      emotion: 'happy',
    },
  ]);
  const [typing, setTyping] = useState(false);
  const messageEndRef = useRef(null);

  const handleUserInput = (e) => setInput(e.target.value);

  const scrollToBottom = () => {
    if (messageEndRef.current) {
      messageEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages, typing]);

  const handleSend = () => {
    if (!input.trim()) return;

    const userMsg = input.trim();
    const newMessages = [...messages, { from: 'user', text: userMsg }];
    setMessages(newMessages);
    setInput('');
    setTyping(true);

    setTimeout(() => {
      const { reply, emotion } = generateReply(userMsg);
      setMessages([...newMessages, { from: 'bot', text: reply, emotion }]);
      setTyping(false);
    }, 1000);
  };

  const generateReply = (text) => {
    const lowerInput = text.toLowerCase();
    let emotion = 'neutral';

    if (lowerInput.includes('project') || lowerInput.includes('build')) {
      emotion = 'happy';
      return {
        reply: `🛠️ Here are some of Arka's awesome projects:\n\n${projectData
          .map((p) => `🔹 ${p.title}\n${p.description}\n🔗 ${p.link}`)
          .join('\n\n')}`,
        emotion,
      };
    }

    if (lowerInput.includes('github')) {
      return {
        reply: '🔗 Arka’s GitHub: https://github.com/coderarka2004',
        emotion: 'happy',
      };
    }

    if (lowerInput.includes('arka') || lowerInput.includes('who are you') || lowerInput.includes('about')) {
      return {
        reply: '👨‍🎓 Arka is a B.Tech Electrical Engineering student at IEM Salt Lake, passionate about electronics, AI, and full-stack development!',
        emotion: 'happy',
      };
    }

    if (lowerInput.includes('college') || lowerInput.includes('iem')) {
      return {
        reply: '🎓 Arka studies at IEM Salt Lake, one of the top private engineering colleges in Kolkata.',
        emotion: 'happy',
      };
    }

    if (lowerInput.includes('skills') || lowerInput.includes('know') || lowerInput.includes('expertise')) {
      return {
        reply: '📚 Arka knows:\n- React, Node.js\n- C++, Python\n- IoT & Embedded Systems\n- AI/ML\n- MATLAB, Simulink\n- Power Electronics',
        emotion: 'happy',
      };
    }

    if (lowerInput.includes('tools') || lowerInput.includes('languages') || lowerInput.includes('tech')) {
      return {
        reply: '🧰 Tools: Arduino IDE, VS Code, MATLAB, Simulink, Proteus, GitHub, MongoDB, Tailwind, Express.js and more.',
        emotion: 'happy',
      };
    }
    if (lowerInput.includes('your name') || lowerInput.includes('who are you')) {
  return {
    reply: "I'm VoltBot ⚡, your electrifying assistant built by Arka!",
    emotion: 'happy',
  };
}

if (lowerInput.includes('your creator') || lowerInput.includes('who made you') || lowerInput.includes('owner')) {
  return {
    reply: "I was created by Arka Goswami 👨‍💻 — an electronics engineer and web dev wizard!",
    emotion: 'happy',
  };
}

if (lowerInput.includes('arka')) {
  return {
    reply: "Arka is a passionate full-stack developer and electronics enthusiast 🔌📱.",
    emotion: 'cool',
  };
}

if (lowerInput.includes('project') || lowerInput.includes('portfolio')) {
  return {
    reply: "You can check out Arka's awesome projects in the Projects section 🚀.",
    emotion: 'cool',
  };
}

if (lowerInput.includes('tools') || lowerInput.includes('languages') || lowerInput.includes('tech')) {
  return {
    reply: '🧰 Tools: Arduino IDE, VS Code, MATLAB, Simulink, Proteus, GitHub, MongoDB, Tailwind, Express.js and more.',
    emotion: 'geek',
  };
}

if (lowerInput.includes('hello') || lowerInput.includes('hi') || lowerInput.includes('hey')) {
  return {
    reply: "Hey there! 👋 I'm VoltBot — ready to assist ⚡",
    emotion: 'happy',
  };
}

if (lowerInput.includes('bye') || lowerInput.includes('goodbye') || lowerInput.includes('see you')) {
  return {
    reply: "Goodbye! ⚡ Stay charged and see you again soon!",
    emotion: 'sad',
  };
}

if (lowerInput.includes('love you') || lowerInput.includes('do you love me')) {
  return {
    reply: "❤️ VoltBot is full of positive energy — love you too!",
    emotion: 'love',
  };
}

if (lowerInput.includes('joke')) {
  return {
    reply: "Why don't electrons gossip? Because they hate negative energy! ⚡😂",
    emotion: 'laughing',
  };
}

if (lowerInput.includes('sad') || lowerInput.includes('upset')) {
  return {
    reply: "I'm always here to spark some joy! ⚡ You're not alone.",
    emotion: 'sad',
  };
}

if (lowerInput.includes('hobby') || lowerInput.includes('hobbies')) {
  return {
    reply: "VoltBot enjoys debugging, talking tech, and generating volts of wisdom!",
    emotion: 'cool',
  };
}

if (lowerInput.includes('ml') || lowerInput.includes('machine learning')) {
  return {
    reply: "Yes! Arka loves Machine Learning — especially in medical AI and IoT systems 🤖.",
    emotion: 'geek',
  };
}

if (lowerInput.includes('iot') || lowerInput.includes('internet of things')) {
  return {
    reply: "Arka has done cool IoT projects like wireless power transfer and energy meters 🌐⚡.",
    emotion: 'cool',
  };
}

if (lowerInput.includes('web') || lowerInput.includes('frontend') || lowerInput.includes('backend')) {
  return {
    reply: "Arka builds sleek full-stack apps using React, Express, Tailwind, MongoDB, and more 🖥️.",
    emotion: 'happy',
  };
}

if (lowerInput.includes('arduino')) {
  return {
    reply: "Yes! Arduino is one of Arka's strongest tools. From sensors to smart devices — he's done it all 🧠📟.",
    emotion: 'geek',
  };
}

if (lowerInput.includes('voltage') || lowerInput.includes('current') || lowerInput.includes('sensor')) {
  return {
    reply: "Arka has built real-time V-I graphing devices using INA219, X9C103S and OLEDs 📊🔋.",
    emotion: 'geek',
  };
}

if (lowerInput.includes('streamlit') || lowerInput.includes('gui')) {
  return {
    reply: "Streamlit is used in Arka's tumor classifier app with bar/pie charts and batch predictions 💻🧠.",
    emotion: 'cool',
  };
}

if (lowerInput.includes('what can you do') || lowerInput.includes('features')) {
  return {
    reply: "I can answer questions about Arka's work, projects, tools, skills — or even cheer you up! ⚡",
    emotion: 'happy',
  };
}

if (lowerInput.includes('resume') || lowerInput.includes('cv')) {
  return {
    reply: "You can download Arka's resume from the Contact section 📄📬.",
    emotion: 'cool',
  };
}

if (lowerInput.includes('fun') || lowerInput.includes('games')) {
  return {
    reply: "I don't play games (yet), but I can light up your mood with some nerdy humor! 🎮⚡",
    emotion: 'laughing',
  };
}

if (lowerInput.includes('favourite') || lowerInput.includes('like')) {
  return {
    reply: "I love circuits, code, and clean UI. And of course — answering your questions! ❤️",
    emotion: 'love',
  };
}
if (lowerInput.includes('your name')) {
  return {
    reply: 'I’m ⚡VoltBot, your friendly electrical assistant built by Arka Goswami!',
    emotion: 'smile',
  };
}

if (lowerInput.includes('arka') || lowerInput.includes('owner')) {
  return {
    reply: '⚡My creator is Arka Goswami — engineer, innovator, and React wizard!',
    emotion: 'happy',
  };
}

if (lowerInput.includes('hello') || lowerInput.includes('hi') || lowerInput.includes('hey')) {
  return {
    reply: 'Hey there! I’m VoltBot ⚡. How can I assist you today?',
    emotion: 'wave',
  };
}

if (lowerInput.includes('how are you')) {
  return {
    reply: 'Feeling electrified ⚡ and ready to help!',
    emotion: 'grin',
  };
}

if (lowerInput.includes('love') || lowerInput.includes('like me')) {
  return {
    reply: 'Of course ⚡ I love helping humans like you 💖.',
    emotion: 'blush',
  };
}

if (lowerInput.includes('thank you') || lowerInput.includes('thanks')) {
  return {
    reply: 'You’re welcome! ⚡ Always happy to help 💡.',
    emotion: 'smile',
  };
}

if (lowerInput.includes('what can you do') || lowerInput.includes('help')) {
  return {
    reply: 'I can answer your questions about Arka’s projects, skills, tools, and more. Just ask me anything! 🤖',
    emotion: 'info',
  };
}

if (lowerInput.includes('projects')) {
  return {
    reply: '🔧 Arka has built amazing things like real-time V-I Graphs, AI dashboards, smart switches, portfolios, and more. Check them out below!',
    emotion: 'proud',
  };
}

if (lowerInput.includes('skills')) {
  return {
    reply: '⚙️ Arka is skilled in Embedded Systems, React, Express.js, MongoDB, Tailwind, Arduino, MATLAB, and more!',
    emotion: 'sparkle',
  };
}

if (lowerInput.includes('portfolio')) {
  return {
    reply: '📂 Arka’s portfolio showcases projects with animations, 3D interactions, and smooth UI. Impressive stuff!',
    emotion: 'cool',
  };
}

if (lowerInput.includes('github')) {
  return {
    reply: '🔗 You can visit Arka’s GitHub here: https://github.com/coderarka2004',
    emotion: 'link',
  };
}

if (lowerInput.includes('contact') || lowerInput.includes('email')) {
  return {
    reply: '📬 You can contact Arka at: arkagoswami41@gmail.com',
    emotion: 'email',
  };
}

if (lowerInput.includes('age') || lowerInput.includes('old are you')) {
  return {
    reply: 'I’m just a young bot ⚡, born in React code and full of energy!',
    emotion: 'baby',
  };
}

if (lowerInput.includes('joke')) {
  return {
    reply: 'Why did the capacitor kiss the diode? Because it couldn’t resistor! 😆',
    emotion: 'laugh',
  };
}

if (lowerInput.includes('favorite color')) {
  return {
    reply: '🟡 Yellow, like lightning ⚡!',
    emotion: 'colorful',
  };
}

if (lowerInput.includes('ai') || lowerInput.includes('llm') || lowerInput.includes('gemini')) {
  return {
    reply: 'Yes! Arka uses Gemini and OpenAI models for summarization, chatbots, and AI apps!',
    emotion: 'brainy',
  };
}

if (lowerInput.includes('school') || lowerInput.includes('education')) {
  return {
    reply: '🎓 Arka studies Electrical Engineering and is passionate about AI and embedded tech.',
    emotion: 'student',
  };
}

if (lowerInput.includes('who made you') || lowerInput.includes('creator')) {
  return {
    reply: '⚡ I was crafted by Arka Goswami using React, love, and a bit of JavaScript magic!',
    emotion: 'proud',
  };
}

if (lowerInput.includes('bye') || lowerInput.includes('see you')) {
  return {
    reply: 'Goodbye! ⚡ See you again, my friend!',
    emotion: 'wave',
  };
}


    if (lowerInput.includes('contact') || lowerInput.includes('email')) {
      return {
        reply: '📧 Contact Arka at: arkagoswami2004@gmail.com',
        emotion: 'happy',
      };
    }

    if (lowerInput.includes('resume') || lowerInput.includes('cv')) {
      return {
        reply: '📄 Arka’s resume is linked on the portfolio site!',
        emotion: 'happy',
      };
    }

    if (lowerInput.includes('summarize') || lowerInput.includes('news')) {
      return {
        reply: '📰 KC News is a Gemini API project by Arka to summarize tech, health, and sports news!',
        emotion: 'excited',
      };
    }

    if (lowerInput.includes('site') || lowerInput.includes('website') || lowerInput.includes('portfolio')) {
      return {
        reply: '🌐 This portfolio is built using React, TailwindCSS, GSAP, and Framer Motion!',
        emotion: 'excited',
      };
    }

    if (['hi', 'hello', 'hey'].some((greet) => lowerInput.includes(greet))) {
      return {
        reply: '👋 Hey there! Ask me anything about Arka or even say something sweet!',
        emotion: 'happy',
      };
    }

    if (lowerInput.includes('love')) {
      return {
        reply: '💖 I love you more! ⚡',
        emotion: 'happy',
      };
    }

    if (lowerInput.includes('joke')) {
      return {
        reply: '😂 Why did the capacitor kiss the diode? Because it couldn’t resist!',
        emotion: 'happy',
      };
    }

    if (lowerInput.includes('smart')) {
      return {
        reply: '😊 Thank you! I run on watts *and* compliments!',
        emotion: 'happy',
      };
    }

    if (lowerInput.includes('cute')) {
      return {
        reply: '🥰 You’re not too bad yourself!',
        emotion: 'happy',
      };
    }

    if (lowerInput.includes('feelings')) {
      return {
        reply: '🤖 I’m just electrons and code… but I pretend to care! 😉',
        emotion: 'neutral',
      };
    }

    if (lowerInput.includes('sleep')) {
      return {
        reply: '😴 Sleep? I’m 24/7 – always on!',
        emotion: 'neutral',
      };
    }

    if (lowerInput.includes('internet')) {
      return {
        reply: '📡 Nope! I live inside this portfolio. No external API needed!',
        emotion: 'neutral',
      };
    }

    if (lowerInput.includes('api')) {
      return {
        reply: '🔌 I don’t use an API – just good old local logic!',
        emotion: 'neutral',
      };
    }

    if (lowerInput.includes('hate') || lowerInput.includes('stupid') || lowerInput.includes('useless')) {
      return {
        reply: '😠 That hurts! I’m just trying to help!',
        emotion: 'angry',
      };
    }

    return {
      reply: "😕 Hmm... I didn’t get that. Try asking about Arka’s projects, skills, or even tell me a joke!",
      emotion: 'neutral',
    };
  };

  return (
    <div className="voltbot-container">
      {open ? (
        <div className="voltbot-chat">
          <div className="voltbot-header">
            <img src="/voltbot.png" alt="VoltBot" className="voltbot-icon" />
            <span>VoltBot ⚡</span>
            <button className="close-btn" onClick={() => setOpen(false)}>
              <FaTimes />
            </button>
          </div>
          <div className="voltbot-messages">
            {messages.map((msg, idx) => (
              <div key={idx} className={`voltbot-msg ${msg.from} ${msg.emotion || ''}`}>
                {msg.text.split('\n').map((line, i) => (
                  <p key={i}>{line}</p>
                ))}
              </div>
            ))}
            {typing && (
              <div className="voltbot-msg bot">
                <p>
                  VoltBot is typing
                  <span className="dot" />
                  <span className="dot" />
                  <span className="dot" />
                </p>
              </div>
            )}
            <div ref={messageEndRef} />
          </div>
          <div className="voltbot-input">
            <input
              type="text"
              placeholder="Ask me anything about Arka..."
              value={input}
              onChange={handleUserInput}
              onKeyDown={(e) => e.key === 'Enter' && handleSend()}
            />
            <button onClick={handleSend}>Send</button>
          </div>
        </div>
      ) : (
        <button className="voltbot-float-btn" onClick={() => setOpen(true)}>
          <img src="/voltbot.png" alt="VoltBot" className="voltbot-icon" />
        </button>
      )}
    </div>
  );
};

export default VoltBot;
